import React from "react";
import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import Login from "@/pages/Login";
import { HousekeepingList, HousekeepingNew } from "@/pages/Housekeeping";
import Maintenance from "@/pages/Maintenance";
import MaintenanceNew from "@/pages/MaintenanceNew";
import Purchasing from "@/pages/Purchasing";
import Management from "@/pages/Management";
import Consola from "@/pages/Consola";
import ReportDetail from "@/pages/ReportDetail";
import DemoTour from "@/pages/DemoTour";
import InstallPrompt from "@/components/InstallPrompt";

function Guard({ roles, children }) {
  const { session, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-sm text-[color:var(--q-muted)]">Cargando…</div>;
  if (!session) return <Navigate to="/login" replace/>;
  if (roles && !roles.includes(session.user.role)) return <Navigate to="/" replace/>;
  return children;
}

function RoleHome() {
  const { session } = useAuth();
  if (!session) return <Navigate to="/login" replace/>;
  const r = session.user.role;
  if (r === "quilla_admin") return <Navigate to="/consola" replace/>;
  if (r === "housekeeping") return <Navigate to="/housekeeping" replace/>;
  if (r === "mantenimiento") return <Navigate to="/mantenimiento" replace/>;
  if (r === "compras") return <Navigate to="/compras" replace/>;
  if (r === "gerencia") return <Navigate to="/gerencia" replace/>;
  return <Navigate to="/login" replace/>;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors/>
        <InstallPrompt/>
        <Routes>
          <Route path="/login" element={<Login/>}/>
          <Route path="/demo" element={<DemoTour/>}/>
          <Route path="/" element={<RoleHome/>}/>
          <Route path="/housekeeping" element={<Guard roles={["housekeeping"]}><HousekeepingList/></Guard>}/>
          <Route path="/housekeeping/new" element={<Guard roles={["housekeeping"]}><HousekeepingNew/></Guard>}/>
          <Route path="/mantenimiento" element={<Guard roles={["mantenimiento"]}><Maintenance/></Guard>}/>
          <Route path="/mantenimiento/new" element={<Guard roles={["mantenimiento"]}><MaintenanceNew/></Guard>}/>
          <Route path="/compras" element={<Guard roles={["compras"]}><Purchasing/></Guard>}/>
          <Route path="/gerencia" element={<Guard roles={["gerencia"]}><Management/></Guard>}/>
          <Route path="/consola" element={<Guard roles={["quilla_admin"]}><Consola/></Guard>}/>
          <Route path="/report/:id" element={<Guard roles={["housekeeping","mantenimiento","compras","gerencia"]}><ReportDetail/></Guard>}/>
          <Route path="*" element={<Navigate to="/" replace/>}/>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
